import React, { useState } from 'react';
import { ChevronRight } from 'lucide-react';
import ReactMarkdown from 'react-markdown';
import { useLocale } from '../../contexts/LocaleContext';
import { FAQ_ITEMS } from '../faq-items';

export const FAQ: React.FC = () => {
  const { t } = useLocale();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="scroll-mt-24 bg-white" style={{ padding: '110px 0 120px' }}>
      <div style={{ width: '100%', maxWidth: '1200px', margin: '0 auto', padding: '0 32px' }}>
        <div style={{ textAlign: 'center', marginBottom: '56px' }}>
          <h2 style={{
            fontFamily: "'Inter', system-ui, sans-serif",
            fontWeight: 300,
            fontSize: 'clamp(34px, 5vw, 56px)',
            lineHeight: 1.06,
            letterSpacing: '-0.02em',
            margin: '0 0 18px',
            color: 'rgb(39,39,41)',
          }}>
            <strong style={{ fontWeight: 800 }}>{t('landing_faq_title').split(' ')[0]}</strong>
            {' '}{t('landing_faq_title').split(' ').slice(1).join(' ')}
          </h2>
          <p style={{
            fontFamily: "'Inter', system-ui, sans-serif",
            fontSize: '18px',
            lineHeight: '24px',
            fontWeight: 400,
            letterSpacing: '0px',
            color: 'rgba(39,39,41,0.7)',
            margin: 0,
          }}>
            {t('landing_faq_subtitle')}
          </p>
        </div>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          maxWidth: '820px',
          margin: '0 auto',
        }}>
          {FAQ_ITEMS.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={faq.questionKey}
                style={{
                  border: '1px solid #e7e7e8',
                  borderRadius: '12px',
                  background: '#fff',
                  overflow: 'hidden',
                }}
              >
                <button
                  type="button"
                  aria-expanded={isOpen}
                  aria-controls={`faq-answer-${index}`}
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '16px',
                    padding: '22px 28px',
                    textAlign: 'left',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontFamily: "'Inter', system-ui, sans-serif",
                    fontSize: '18px',
                    fontWeight: 400,
                    lineHeight: 1.4,
                    color: 'rgb(39,39,41)',
                  }}
                >
                  {t(faq.questionKey)}
                  <ChevronRight
                    size={18}
                    style={{
                      flexShrink: 0,
                      color: 'rgb(39,39,41)',
                      transition: 'transform 220ms cubic-bezier(0.22,1,0.36,1)',
                      transform: isOpen ? 'rotate(90deg)' : 'none',
                    }}
                  />
                </button>
                <div
                  id={`faq-answer-${index}`}
                  aria-hidden={!isOpen}
                  style={{
                    padding: isOpen ? '0 28px 22px' : '0 28px',
                    fontFamily: "'Inter', system-ui, sans-serif",
                    fontSize: '16px',
                    lineHeight: 1.6,
                    color: 'rgba(39,39,41,0.7)',
                    maxHeight: isOpen ? '2000px' : '0',
                    overflow: 'hidden',
                    opacity: isOpen ? 1 : 0,
                    transition: 'max-height 220ms cubic-bezier(0.22,1,0.36,1), opacity 180ms ease, padding 220ms ease',
                  }}
                >
                  <ReactMarkdown>{t(faq.answerKey)}</ReactMarkdown>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};
